import { create } from 'zustand';

interface UpgradeDialogState {
  open: boolean;
  setOpen: (open: boolean) => void;
}

// §23.4 - every 402 PLAN_EXPIRED from any action re-opens this dialog; the
// server is the enforcer, the dialog is the answer (buttons stay enabled).
export const useUpgradeDialogStore = create<UpgradeDialogState>((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
}));
